/* eslint-disable no-console */
/* global process */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
	let refreshing = false

	navigator.serviceWorker.addEventListener('controllerchange', () => {
		if (refreshing) return

		const RELOAD_KEY = 'sw_reload_ts'
		const RELOAD_COOLDOWN = 10000
		const lastReload = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0')
		const now = Date.now()

		if (now - lastReload < RELOAD_COOLDOWN) {
			console.warn('Service worker reload loop detected, suppressing reload.')
			return
		}

		refreshing = true
		sessionStorage.setItem(RELOAD_KEY, String(now))
		console.log('New service worker activated, refreshing...')
		window.location.reload()
	})

	let registration

	register(`${process.env.BASE_URL}service-worker.js`, {
		ready() {
			console.log('App is being served from cache by a service worker.')
		},
		registered(reg) {
			console.log('Service worker has been registered.')
			registration = reg

			document.addEventListener('visibilitychange', () => {
				if (!document.hidden) {
					registration.update()
				}
			})

			registration.onupdatefound = () => {
				const newWorker = registration.installing
				
				if (newWorker) {
					newWorker.onstatechange = () => {
						if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
							console.log('New version available, loading...')
							newWorker.postMessage({ type: 'SKIP_WAITING' })
						}
					}
				}
			}
		},
		updated(reg) {
			if (reg.waiting) {
				console.log('New version available, loading...')
				reg.waiting.postMessage({ type: 'SKIP_WAITING' })
			}
		},
		cached() {
			console.log('Content has been cached for offline use.')
		},
		offline() {
			console.log('No internet connection found. App is running in offline mode.')
		},
		error(error) {
			console.error('Error during service worker registration:', error)
		}
	})
}